import React from 'react'

const cuponsRoutes = [
    {
        path: '/cupons/exclusivos/listar',
        exact: true,
        component: React.lazy(() => import('./exclusivos/lista/CupomExclusivoIndex')),
    },
    {
        path: '/cupons/exclusivos/gerar',
        exact: true,
        component: React.lazy(() => import('./exclusivos/gerar/CupomExclusivoForm')),
    },
    {
        path: '/cupons/exclusivos/editar/:cupomId',
        exact: true,
        component: React.lazy(() => import('./exclusivos/gerar/CupomExclusivoForm')),
    },
    {
        path: '/cupons/exclusivos/visualizar/:cupomId',
        exact: true,
        component: React.lazy(() => import('./exclusivos/gerar/CupomExclusivoForm')),
    },
    {
        path: '/cupons/pontos/listar',
        exact: true,
        component: React.lazy(() => import('./pontos/listar/CupomPontosIndex')),
    },
    {
        path: '/cupons/pontos/gerar',
        exact: true,
        component: React.lazy(() => import('./pontos/gerar/CupomPontosForm')),
    },
    {
        path: '/cupons/pontos/editar/:campanhaId',
        exact: true,
        component: React.lazy(() => import('./pontos/gerar/CupomPontosForm')),
    },
    {
        path: '/cupons/pontos/visualizar/:campanhaId',
        exact: true,
        component: React.lazy(() => import('./pontos/visualizar/CupomPontosIndex')),
    },
    // {
    //     path: '/cupons/resgates',
    //     exact: true,
    //     component: React.lazy(() => import('./resgates/lista/Table')),
    // },
    // {
    //     path: '/cupons/resgates/view',
    //     exact: true,
    //     component: React.lazy(() => import('./resgates/form/Form')),
    // },
]

export default cuponsRoutes
